import styled from "styled-components";

export const LineAddButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0.85rem 2.4rem;
  border: none;
  border-radius: 12px;
  background: #06C755;
  color: white;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(6, 199, 85, 0.35);
  margin-top: 0.5rem;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 28px rgba(6, 199, 85, 0.5);
    background: #05b34d;
    color: white;
    border-bottom: none;
  }

  &:active {
    transform: translateY(0);
  }

  img {
    width: 24px;
    height: 24px;
    border-radius: 0 !important;
  }
`;

export const HeroSection = styled.div`
  text-align: center;
  margin-bottom: 1.5rem;
`;

export const Tagline = styled.p`
  font-size: 1.1rem !important;
  color: rgba(255, 255, 255, 0.75) !important;
  max-width: 34rem;
  margin: 0 auto 1.5rem !important;
`;

export const LINE_BOT_URL = "https://line.me/R/ti/p/@014wkcef";
